import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import api, { fmtErr } from "../lib/api";
import { toast } from "sonner";

const inputCls = "w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm focus:border-shipany-blue focus:outline-none focus:ring-2 focus:ring-shipany-blue/15";

export default function ChangePasswordCard() {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("New passwords do not match");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password updated successfully");
      setForm({ current_password: "", new_password: "", confirm: "" });
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4 rounded-2xl border border-slate-200 bg-white p-6" data-testid="change-password-card">
      <h2 className="font-display flex items-center gap-2 text-lg font-bold text-shipany-navy"><Lock className="h-5 w-5 text-shipany-blue" /> Change Password</h2>
      <p className="text-xs text-slate-400">Verify your current password to set a new one.</p>
      <div>
        <label className="text-xs font-semibold text-slate-500">Current password</label>
        <input data-testid="cp-current" type="password" required className={`${inputCls} mt-1`} value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-semibold text-slate-500">New password</label>
          <input data-testid="cp-new" type="password" required minLength={8} placeholder="Min 8 characters" className={`${inputCls} mt-1`} value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} />
        </div>
        <div>
          <label className="text-xs font-semibold text-slate-500">Confirm new password</label>
          <input data-testid="cp-confirm" type="password" required minLength={8} className={`${inputCls} mt-1`} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} />
        </div>
      </div>
      <button data-testid="cp-submit-btn" disabled={saving} className="flex w-full items-center justify-center gap-2 rounded-xl bg-shipany-blue py-3 text-sm font-bold text-white hover:bg-[#0648B3] disabled:opacity-60">
        {saving && <Loader2 className="h-4 w-4 animate-spin" />} Update Password
      </button>
    </form>
  );
}
